import * as Sentry from '@sentry/browser'
Sentry.init({
	enabled: !isDev(),
  dsn: 'https://215de134d704aa5c2591e2544e46e6f9@o15621.ingest.sentry.io/4505900899237888',
  release: 'rolling',
  integrations: [
    new Sentry.BrowserTracing({
  
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [ /^https:\/\/www\.contexte\.com.+/ ],
    }),
    new Sentry.Replay(),
  ],

  // Performance Monitoring
  tracesSampleRate: .3, // Capture 100% of the transactions, reduce in production!
  
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

import Vue from 'vue'
import App from '../App.vue'
import {redirectDirectAccess, isDev} from 'global/js/apps.js'
import colorsV2 from 'global/css/_contexte.apps.colors.2.0.scss'
const config = require('../config.json')

Vue.config.productionTip = false
Vue.store = Vue.prototype.store = config


// Dev mode ?
Vue.prototype.isDev = isDev()

// Responsive
Vue.prototype.mobile = false
Vue.prototype.largeDisplay = false
Vue.prototype.colors = colorsV2
if (window.innerWidth <= config.breakpoints.mobile) Vue.prototype.mobile = true
if (window.innerWidth >= config.breakpoints.largeDisplay) Vue.prototype.largeDisplay = true

redirectDirectAccess(Vue.store.dzHostId)

new Vue({
  render: h => h(App),
}).$mount('#app')
